import {
    NavLink,
    useParams
} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {moduleConfig} from "../config";

export const IndexPageNavigation = () => {

    const {id: applicationId} = useParams()
    if (!applicationId) {
        throw new Error('applicationId is required');
    }


    const breadcrumbs = [
            {
                title: 'Home',
                href: '/dashboard',
            }, {
                title: 'Applications',
                href: '/applications',
            }, {
                title: 'Application',
                href: `/applications/${applicationId}`,
            }, {
                title: moduleConfig.titles.plural
            }
        ].map((item, index) => (
            <Box key={index}> {
                item
                    .href ?
                    <NavLink to={item.href}>{item.title}</NavLink> : item.title
            }
            </Box>
        ))
    ;
    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};

